import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
var ValidateFormComponent = (function () {
    function ValidateFormComponent(apiService, route, router, commonService) {
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.validateCode = "";
    }
    ValidateFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.newMethodId = params['methodId'];
        });
    };
    ValidateFormComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    ValidateFormComponent.prototype.validate = function () {
        var validateInput = $("#CodeValidateTxt");
        if (this.validateCode != "") {
            validateInput.removeClass('showValidateTxt');
            this.submitValide();
        }
        else {
            validateInput.addClass('showValidateTxt');
        }
    };
    ValidateFormComponent.prototype.submitValide = function () {
        this.gotoLearnMap();
    };
    ValidateFormComponent.prototype.gotoLearnMap = function () {
        var link = ['learning-map', this.newMethodId];
        this.router.navigate(link);
    };
    return ValidateFormComponent;
}());
export { ValidateFormComponent };



// WEBPACK FOOTER //
// ./src/app/validate-form/validate-form.component.ts.pre-build-optimizer.js